import NotFind from '@/pages/ErrorCom/NotFind';

export default [
  {
    path: '/notFound',
    component: NotFind,
  },
];
